<div class="master-card shadow-sm p-4 rounded bg-white">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0 fw-bold text-dark">Master Clients</h3>
        <button class="btn btn-outline-secondary btn-sm rounded-0" (click)="loadClients()">
            <i class="pi pi-refresh"></i>
        </button>
    </div>

    <p-table 
        [value]="clients" 
        [loading]="loading" 
        [rows]="10" 
        [paginator]="true" 
        responsiveLayout="scroll"
        styleClass="p-datatable-sm p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th>ID</th>
                <th>Client ID</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-client>
            <tr>
                <td>{{ client.id }}</td>
                <td class="fw-medium text-primary">{{ client.clientId }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2" class="text-center py-4">No clients found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-toast></p-toast>
